<template>
  <el-header
    height="100px"
    class="pageheader"
    v-if="!$store.state.isHiddenHeader"
  >
    <!-- <router-link class="logo" to="/"></router-link> -->
    <div class="pageheader__title">
      <h2 v-if="$route.meta.subtitle">
        {{ $l($route.meta.title) }}
        <span class="subtitle">{{ $l($route.meta.subtitle) }}</span>
      </h2>
      <h2 v-else>
        {{ $l($route.matched[0].meta.title) }}
        <span v-if="$route.matched[0].redirect && $route.meta.title"
          >｜{{ $l($route.meta.title) }}</span
        >
      </h2>
      <p>{{ $l($route.matched[0].meta.info) }}</p>

      <el-popover
        placement="bottom-start"
        trigger="click"
        v-if="
          $route.matched[0].meta.title == '信息概览' &&
          $store.state.user.userType == 2
        "
      >
        <div class="selarea" slot="reference">
          <svgicon name="location"></svgicon>
          {{ $l($store.state.currentArea[0]) }}
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-cascader-panel
          ref="areaCascaderPanel"
          :options="$store.state.areaNameList"
          :props="areaProps"
          v-model="$store.state.currentArea"
          class="selarea-popper"
          @change="areaChange"
        ></el-cascader-panel>
      </el-popover>
    </div>

    <div
      class="dataSum"
      v-if="
        $route.matched[0].meta.title == '信息概览' &&
        $store.state.isHasIndexPermissions
      "
      v-loading.lock="topLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <div class="dataSum-icon">
        <svgicon name="monitor"></svgicon>
      </div>
      <el-progress
        :percentage="Number(monitorStatusArr[0].percent)"
        :stroke-width="4"
        :show-text="false"
      ></el-progress>
      <ul>
        <li v-for="(item, i) in monitorStatusArr" :key="i">
          <h4>{{ item.text }}</h4>
          <div class="dataSum-num">
            <p class="percent">
              {{ item.percent }}
              <small>%</small>
            </p>
            <p class="number">{{ item.value }}</p>
          </div>
        </li>
      </ul>
      <!-- <h6>
        - {{ $l("最后更新时间：") }}{{ $store.state.trapLastUpdateTime }} -
      </h6> -->
      <!-- <div class="trapTips">
        <el-popover placement="bottom" width="200" trigger="click">
          <p class="tipsContent">
            1、维保人员优先完成现场的救援工作，救援时间节点（到场时间、救援完成时间）可能会滞后上报；
          </p>
          <p class="tipsContent">
            2、困人救援时效统计仅供用户参考管理，具体的时效性要求请按照各自维保合同条款。
          </p>
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </div> -->
    </div>
    <div id="mynotice" class="mynotice" v-if="!deriveLoading">
      <div class="notice" @click="showNotice" slot="reference">
        <!-- <h4>{{ "公告" }}</h4> -->
        <!-- <p>{{ "Notice" }}</p> -->
        <div v-if="noticeList.filter((t) => t.userId == null).length > 0">
          <el-badge :value="noticeList.filter((t) => t.userId == null).length">
            <div class="notice_icon">
              <!-- <img :src="noticeIconUrl" alt="" /> -->
            </div>
          </el-badge>
        </div>
        <div v-else>
          <div class="notice_icon">
            <!-- <img :src="noticeIconUrl" alt="" /> -->
            <svgicon name="bell-line"></svgicon>
          </div>
        </div>
      </div>
      <el-popover placement="bottom" width="300" trigger="click">
        <div class="logout__popover" style="both: clear">
          <el-avatar :src="avatarUrl" fit="cover"></el-avatar>
          <!-- <div class="user_icon">
            <svgicon name="user-line"></svgicon>
          </div> -->
          <h4>{{ user.username }}</h4>
          <p>{{ user.roleName }}</p>
          <p v-if="$store.state.user.telNum">
            {{ $store.state.user.telNum
            }}<a href="#" @click="modifyPhone(3)" style="margin-left: 10px"
              >{{ $l("修改") }} </a
            >&nbsp;<a href="#" @click="modifyPhone(2)">{{ $l("解绑") }} </a>
          </p>
          <p class="modifyPhone" v-else @click="modifyPhone(1)">
            {{ $l("绑定") }}
          </p>
          <div class="btnbar">
            <el-button
              type="primary"
              style="width: 45%"
              :title="$l('修改密码')"
              round
              @click="modifyPassword()"
              >{{ $l("修改密码") }}
            </el-button>
            <el-button type="primary" style="width: 45%" round @click="logout()"
              >{{ $l("退出系统") }}
            </el-button>
          </div>
          <el-dropdown @command="selectedItem">
            <span class="lang_switch">
              <svgicon name="lang_switch"></svgicon>
              <!-- <span>{{ $l("语言") }} </span> -->
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="en"
                >{{ $l("英文") }}
              </el-dropdown-item>
              <!-- <el-dropdown-item command="japanese">日本语</el-dropdown-item> -->
              <el-dropdown-item command="zh"
                >{{ $l("中文") }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div type="flex" class="pageheader__avatar" slot="reference">
          <div style="float: left">
            <h4>{{ user.username }}</h4>
            <p>{{ user.roleName }}</p>
            <p class="expireDate" v-if="user.expireDate">
              {{ $l('"使用到期时间：') + user.expireDate }}
            </p>
          </div>
          <!-- <el-avatar
            :src="avatarUrl"
            fit="cover"
            style="float: right"
          ></el-avatar> -->
          <div class="user_icon">
            <svgicon name="user-line" :fill="false"></svgicon>
          </div>
          <!-- <li @click="logout()"><i class="logout"></i>退出</li> -->
        </div>
      </el-popover>
    </div>
    <div v-else class="logo-img">
      <img :src="require('@/assets/img/logo.png')" alt="" />
    </div>
    <el-dialog
      :title="$l('修改密码')"
      width="500px"
      :visible.sync="modifyPasswordDialogVisible"
      :modal-append-to-body="false"
      style="z-index: 2001"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        size="small"
        class="dialog-form"
      >
        <el-form-item :label="$l('原密码')" prop="oldPassword">
          <el-input
            type="password"
            v-model="form.oldPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$l('新密码')" prop="newPassword">
          <el-input
            type="password"
            v-model="form.newPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$l('确认密码')" prop="rePassword">
          <el-input
            type="password"
            v-model="form.rePassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="modifyPasswordDialogVisible = false"
          >{{ $l("取消") }}
        </el-button>
        <el-button round type="primary" @click="modifyPasswordSubmit"
          >{{ $l("确定") }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$l('最新公告')"
      :visible.sync="noticeDialogVisible"
      :modal-append-to-body="false"
      width="800px"
      class="noticeDialog"
    >
      <ul>
        <li
          v-for="(item, index) in noticeList.filter((t) => t.userId == null)"
          :key="index"
          @click="showNoticeDetail(item)"
        >
          <span class="unread"></span>{{ item.title }}
          <p>{{ item.startDate }}</p>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="noticeDialogVisible = false"
          >{{ $l("取消") }}
        </el-button>
        <el-button round type="primary" @click="skipHistoryNotice"
          >{{ $l("历史公告") }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$l('公告详情')"
      :visible.sync="noticeDetailDialogVisible"
      :modal-append-to-body="false"
      width="800px"
      class="noticeDetailDialog"
    >
      <h3>{{ notice.title }}</h3>
      <p>{{ notice.content }}</p>
      <div>
        <span>{{ notice.creator }}</span>
        <span>{{ notice.startDate }}</span>
      </div>
    </el-dialog>

    <el-dialog
      :title="modifyPhoneType == 3 ? $l('修改手机号') : $l('绑定手机号')"
      width="360px"
      :visible.sync="modifyPhoneDialogVisible"
      :modal-append-to-body="false"
    >
      <el-form
        ref="modifyPhoneForm"
        :model="form"
        label-width="100px"
        size="small"
        class="dialog-form"
      >
        <el-form-item :label="$l('手机号')">
          <el-input placeholder v-model="form.telNum" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$l('短信验证码')">
          <el-input v-model="form.smsCode" class="smsCodeInput" clearable>
          </el-input>
          <el-button
            type="primary"
            class="smsCodeBtn"
            :title="$l(smsCodeText)"
            :disabled="smsLoading || smsCodeSeconds > 0"
            @click="getSmsCode"
            v-loading.lock="smsLoading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.5)"
            >{{ $l(smsCodeText) }}</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="modifyPhoneDialogVisible = false"
          >{{ $l("取消") }}
        </el-button>
        <el-button round type="primary" @click="modifyPhoneSubmit"
          >{{ $l("确定") }}
        </el-button>
      </div>
    </el-dialog>
  </el-header>
</template>

<script>
import global from "@/mixins/global.js";
import { mapGetters } from "vuex";
export default {
  name: "pageheader",
  mixins: [global],
  props: {},
  data() {
    var validateOldPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$l("请输入原密码")));
      } else if (!this.$common.validatePassword(value)) {
        callback(
          new Error(
            this.$l("必须包含字母、数字、特殊字符，至少8字符，不超过16个字符！")
          )
        );
      } else {
        callback();
      }
    };
    var validateNewPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$l("请输入新密码")));
      } else if (!this.$common.validatePassword(value)) {
        callback(
          new Error(
            this.$l("必须包含字母、数字、特殊字符，至少8字符，不超过16个字符！")
          )
        );
      } else {
        if (this.form.rePassword !== "") {
          this.$refs.form.validateField("rePassword");
        }
        callback();
      }
    };
    var validateRePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$l("请再次输入密码")));
      } else if (value !== this.form.newPassword) {
        callback(new Error(this.$l("两次输入密码不一致!")));
      } else {
        callback();
      }
    };
    var validateTelNum = (rule, value, callback) => {
      if (
        value != null &&
        value.trim().length > 0 &&
        (isNaN(value) || value.indexOf(".") >= 0)
      ) {
        callback(new Error(this.$l("请输入数字!")));
      } else {
        callback();
      }
    };
    return {
      avatarUrl: require("@/assets/img/user_head.png"),
      noticeIconUrl: require("@/assets/img/notice.png"),
      areaProps: {
        value: "id",
        label: "name",
      },
      dataPermissionList: [],
      topLoading: false,
      form: {
        oldPassword: "",
        newPassword: "",
        rePassword: "",
        telNum: "",
        smsCode: "",
      },
      rules: {
        oldPassword: [{ validator: validateOldPassword, trigger: "blur" }],
        newPassword: [{ validator: validateNewPassword, trigger: "blur" }],
        rePassword: [{ validator: validateRePassword, trigger: "blur" }],
        telNum: [
          { validator: validateTelNum, trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: this.$l("长度在 11 个字符"),
            trigger: "blur",
          },
        ],
      },
      modifyPasswordDialogVisible: false,
      noticeDialogVisible: false,
      noticeList: [],
      noticeLoading: false,
      noticeDetailDialogVisible: false,
      notice: {},
      monitorStatusArr: [
        { type: 1, value: 0, text: this.$l("正常监视"), percent: 0 },
        { type: 0, value: 0, text: this.$l("未正常监视"), percent: 0 },
      ],
      modifyPhoneDialogVisible: false,
      modifyPhoneType: 1,
      smsLoading: false,
      smsCodeSeconds: 0,
      smsCodeText: "获取验证码",
      smsCodeTimer: null,
    };
  },
  created() {
    this.user = this.$store.state.user;
  },
  computed: {
    ...mapGetters(["deriveLoading"]),
  },
  methods: {
    // statisticsTrap() {
    //   this.$store.state.trapLastUpdateTime =
    //     this.$common.formatCurrentDateTime();
    //   this.topLoading = true;
    //   this.$http
    //     .post(this.$apiConfig.statistics_trap_url, {
    //       dataPermissionList: this.dataPermissionList,
    //       curTime: this.$common.formatDate(),
    //     })
    //     .then((response) => {
    //       this.topLoading = false;
    //       let result = response.data;
    //       if (result.code == 0) {
    //         let data = result.data;
    //         for (var key in this.$store.state.faultTask) {
    //           this.$store.state.faultTask[key] = data[key];
    //         }
    //         if (!this.$store.state.trapTimer) {
    //           if (this.isLoadTop()) {
    //             this.openTopTimer();
    //           }
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       this.topLoading = false;
    //       this.$sentry.captureException(error);
    //       if (!this.$store.state.trapTimer) {
    //         if (this.isLoadTop()) {
    //           this.openTopTimer();
    //         }
    //       }
    //     });
    // },
    statisticsMonitorStatusCount() {
      this.$store.state.trapLastUpdateTime =
        this.$common.formatCurrentDateTime();
      this.topLoading = true;
      this.$http
        .post(this.$apiConfig.statistics_device_status_count_url, {
          type: 2,
          dataPermissionList: this.dataPermissionList,
        })
        .then((response) => {
          this.topLoading = false;
          let result = response.data;
          if (result.code == 0) {
            let arr = result.data;
            let totalCount = arr.reduce((a, b) => a + b.value, 0);
            this.monitorStatusArr = arr.map((t, i) => {
              return {
                type: t.name,
                value: t.value,
                text: this.monitorStatusArr[i].text,
                percent: ((t.value / totalCount) * 100).toFixed(2),
              };
            });
            if (
              !this.$store.state.indexDeviceStatusTimer ||
              this.$store.state.indexDeviceStatusTimer == -1
            ) {
              if (this.isLoadTop()) {
                this.openTopTimer();
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.topLoading = false;
          this.$sentry.captureException(error);
          if (
            !this.$store.state.indexDeviceStatusTimer ||
            this.$store.state.indexDeviceStatusTimer == -1
          ) {
            if (this.isLoadTop()) {
              this.openTopTimer();
            }
          }
        });
    },
    openTopTimer() {
      window.clearTimeout(this.$store.state.indexDeviceStatusTime);
      this.$store.state.indexDeviceStatusTimer = window.setTimeout(() => {
        this.$store.state.isLoadTop = true;
        this.$store.state.indexDeviceStatusTimer = null;
        this.statisticsMonitorStatusCount();
      }, window.config.indexDeviceStatusTimerInterval);

      // this.$store.state.trapTimer = window.setTimeout(() => {
      //   this.$store.state.isLoadTop = true;
      //   this.$store.state.trapTimer = null;
      //   this.statisticsTrap();
      // }, window.config.indexTrapTimerInterval);
    },
    loadAreaData() {
      if (this.$store.state.user.userType == 1) return;
      this.$store.state.currentArea = ["全部"];
      this.$store.state.areaNameList = [{ id: "全部", name: "全部" }];
      this.$http
        .get(this.$apiConfig.get_account_data_permission_url, {
          params: {
            level: 0,
            userType: 2,
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.code == 0) {
            let tempArr = [{ id: "全部", name: "全部" }];
            // this.areaOptions.push({ id: "全部", name: "全部" });
            result.data.forEach((item, i) => {
              tempArr.push(item);
            });
            this.$store.state.areaNameList = tempArr;
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    areaChange(node) {
      const name = node[0];
      this.$store.state.dataPermissionList = [name];
      document.body.click();
      this.dataPermissionList = name == "全部" ? [] : [name];
      // if (this.$store.state.trapTimer) {
      //   window.clearTimeout(this.$store.state.trapTimer);
      //   this.$store.state.trapTimer = null;
      // }
      // this.statisticsTrap();
      if (this.$store.state.indexDeviceStatusTimer) {
        window.clearTimeout(this.$store.state.indexDeviceStatusTimer);
        this.$store.state.indexDeviceStatusTimer = null;
      }
      this.statisticsMonitorStatusCount();
    },
    breakAlarm(type) {
      this.$router.push({
        path: "/manage/alarm",
        query: {
          type: type,
        },
      });
      // window.location.href = "/manage/alarm?type=" + type;
    },
    logout() {
      this.$confirm(this.$l("确认退出吗?"), this.$l("退出系统"), {
        type: "warning",
      })
        .then(() => {
          this.$http
            .get(this.$apiConfig.user_logout_url, {
              params: {
                token: localStorage.getItem("token"),
              },
            })
            .then((response) => {
              this.$store.state.isStopAlarmTips = true;
              window.clearTimeout(this.$store.state.alarmTipsTimer);
              if (this.$store.state.notify) {
                this.$store.state.notify.close();
              }
              this.$store.state.alarmTipsTimer = null;
              localStorage.clear();
              sessionStorage.clear();
              this.$store.state.isExitNotice = true;
              this.$router.push({ path: "/login" });
              this.$store.commit("setRouterTabList", []);
            })
            .catch((error) => {
              this.$sentry.captureException(error);
            });
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    modifyPassword() {
      this.modifyPasswordDialogVisible = true;
    },
    modifyPasswordSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http
            .post(this.$apiConfig.user_password_modify_url, {
              password: this.$md5(this.form.oldPassword),
              newPassword: this.$md5(this.form.newPassword),
            })
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.modifyPasswordDialogVisible = false;
                this.form.oldPassword = "";
                this.form.newPassword = "";
                this.form.rePassword = "";
              }
            })
            .catch((error) => {
              this.message(1, "修改失败");
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    getSmsCode() {
      const telNum = this.form.telNum;
      if (
        !telNum ||
        telNum.length != 11 ||
        isNaN(telNum) ||
        telNum.indexOf(".") >= 0
      ) {
        this.message(-1, "请输入手机号长度为11位的数字");
        return;
      }
      this.smsLoading = true;
      this.$http
        .get(this.$apiConfig.get_sms_code_url, {
          params: {
            telNum,
          },
        })
        .then((response) => {
          this.smsLoading = false;
          let result = response.data;
          this.message(result.code, result.msg);
          const code = result.code;
          if (code == 0 || code == 400) {
            this.smsCodeSeconds = parseInt(result.data);
            this.smsCodeText = this.smsCodeSeconds + "s";
            this.smsCodeTimer = window.setInterval(() => {
              this.smsCodeSeconds--;
              if (this.smsCodeSeconds <= 0) {
                window.clearInterval(this.smsCodeTimer);
                this.smsCodeText = "获取验证码";
                this.smsCodeSeconds = 0;
              } else {
                this.smsCodeText = this.smsCodeSeconds + "s";
              }
            }, 1000);
          }
        })
        .catch((error) => {
          this.smsLoading = false;
          this.message(-1, "获取失败");
          this.$sentry.captureException(error);
        });
    },
    modifyPhone(type) {
      this.modifyPhoneType = type;
      this.form.telNum = this.$store.state.user.telNum;
      if (type != 2) {
        this.modifyPhoneDialogVisible = true;
      } else {
        this.confirmAlert(() => {
          this.modifyPhoneSubmit();
        }, "您确认要解绑当前手机号吗？");
      }
    },
    modifyPhoneSubmit() {
      const type = this.modifyPhoneType;
      if (type != 2) {
        const telNum = this.form.telNum;
        if (
          !telNum ||
          telNum.length != 11 ||
          isNaN(telNum) ||
          telNum.indexOf(".") >= 0
        ) {
          this.message(-1, "请输入手机号长度为11位的数字");
          return;
        }
        if (!this.form.smsCode || this.form.smsCode.length != 6) {
          this.message(1, "请输入短信验证码，长度6个字符");
          return;
        }
      }
      this.$http
        .post(this.$apiConfig.user_phone_modify_url, {
          userId: this.$store.state.user.userId,
          telNum: type == 2 ? "" : this.form.telNum,
          smsCode: this.form.smsCode,
        })
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.message(
              result.code,
              (type == 1 ? "绑定" : type == 2 ? "解绑" : "修改") + "成功"
            );
            const userJson = localStorage.getItem("user");
            if (userJson) {
              let user = JSON.parse(userJson);
              if (type == 2) {
                this.form.telNum = "";
              }
              user.telNum = this.form.telNum;
              localStorage.setItem("user", JSON.stringify(user));
              this.$store.state.user = user;
              this.modifyPhoneDialogVisible = false;
            }
          } else {
            if (result.msg.indexOf("失败") > 0) {
              this.message(
                1,
                (type == 1 ? "绑定" : type == 2 ? "解绑" : "修改") + "失败"
              );
            } else {
              this.message(result.code, result.msg);
            }
          }
          if (this.smsCodeTimer) {
            window.clearInterval(this.smsCodeTimer);
            this.smsCodeTimer = null;
            this.smsCodeSeconds = 0;
            this.smsCodeText = "获取验证码";
          }
        })
        .catch((error) => {
          if (this.smsCodeTimer) {
            window.clearInterval(this.smsCodeTimer);
            this.smsCodeTimer = null;
            this.smsCodeSeconds = 0;
            this.smsCodeText = "获取验证码";
          }
          this.message(
            1,
            (type == 1 ? "绑定" : type == 2 ? "解绑" : "修改") + "失败"
          );
          this.$sentry.captureException(error);
        });
    },
    changeLang() {},

    selectedItem(command) {
      this.$store.commit("SET_LOCALE", command);
      this.$setLocale(command);
    },
    isLoadTop() {
      let name = this.$route.matched[0].name;
      if (this.$route.matched.length == 2) {
        name = this.$route.matched[1].name;
      }
      return name == "indexInfo";
    },
    loadNotice(interval) {
      if (this.$store.state.isExitNotice) {
        this.$store.state.noticeTimer = -1;
        return;
      }
      this.$store.state.noticeTimer = window.setTimeout(() => {
        if (this.$store.state.isExitNotice) {
          this.$store.state.noticeTimer = -1;
          return;
        }
        this.$http
          .get(this.$apiConfig.search_user_notice_url)
          .then((response) => {
            let result = response.data;
            if (result.code == 0) {
              this.noticeList = result.data;
            }
            if (!this.$store.state.isExitNotice) {
              this.loadNotice(window.config.noticeTimerInterval);
            }
            if (result.code == 502) {
              this.message(1, result.msg);
            }
          })
          .catch((error) => {
            if (!this.$store.state.isExitNotice) {
              this.loadNotice(window.config.noticeTimerInterval);
            }
            this.$sentry.captureException(error);
          });
      }, interval);
    },
    showNotice() {
      this.noticeDialogVisible = true;
      this.$http
        .get(this.$apiConfig.search_user_notice_url)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.noticeList = result.data;
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    showNoticeDetail(item) {
      this.notice = item;
      for (let i = 0; i < this.noticeList.length; i++) {
        let tempNotice = this.noticeList[i];
        if (tempNotice.id == item.id) {
          tempNotice.userId = 1;
          break;
        }
      }
      this.noticeDetailDialogVisible = true;
      this.$http
        .post(this.$apiConfig.add_user_notice_url, {
          noticeId: item.id,
        })
        .then((response) => {})
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    skipHistoryNotice() {
      this.noticeDialogVisible = false;
      this.$router.push("/info/historyNotice");
    },
  },
  mounted() {
    if (this.$store.state.isLoadTop) {
      this.$store.state.isLoadTop = false;
      if (this.isLoadTop()) {
        this.loadAreaData();
        this.$store.state.isHasIndexPermissions =
          this.hasIndexPermission("遥监设备状态");
        if (
          this.$store.state.isHasIndexPermissions &&
          (!this.$store.state.indexDeviceStatusTimer ||
            this.$store.state.indexDeviceStatusTimer == -1 ||
            this.monitorStatusArr.filter((t) => t.value > 0).length == 0)
        ) {
          if (this.$store.state.indexDeviceStatusTimer) {
            window.clearTimeout(this.$store.state.indexDeviceStatusTimer);
            this.$store.state.indexDeviceStatusTimer = null;
          }
          this.statisticsMonitorStatusCount();
        }
      } else this.$store.state.isLoadTop = true;
    }
    if (this.$store.state.noticeTimer == -1) {
      this.$store.state.isExitNotice = false;
      this.loadNotice(1000);
    }
  },
  activated() {
    this.$store.state.isHasIndexPermissions =
      this.hasIndexPermission("遥监设备状态");
    this.$store.state.isLoadTop = true;
    if (
      !this.$store.state.indexDeviceStatusTimer ||
      this.$store.state.indexDeviceStatusTimer == -1
    ) {
      this.openTopTimer();
    }
    // if (this.$store.state.trapTimer) {
    //   window.clearTimeout(this.$store.state.trapTimer);
    //   this.$store.state.trapTimer = null;
    // }
  },
  beforeDestroy() {
    this.$store.state.isLoadTop = true;
    if (this.$store.state.indexDeviceStatusTimer) {
      window.clearTimeout(this.$store.state.indexDeviceStatusTimer);
      this.$store.state.indexDeviceStatusTimer = null;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.pageheader {
  position: relative;
  display: flex;
  justify-content: space-around;
  padding-left: 0;
  // background: $--background-color-base;
  // width: 100%;
  // background: #fff;
  // background-size: cover;
  &:before {
    content: "";
    position: absolute;
    top: 25%;
    left: 0;
    height: 50%;
    border-left: 1px solid rgba(#000, 0.08);
  }
  &__title {
    padding-top: 20px;
    flex: 1;
    // color: $--color-primary;
    padding-left: 22px;

    h2 {
      font-size: 28px;
      // font-weight: bold;
      padding-left: 0px;
      margin: 0;
      line-height: 35px;
    }

    p {
      color: #9fa0a0;
      font-size: 16px;
      letter-spacing: 1px;
    }
  }

  &__avatar {
    text-align: right;

    h4 {
      font-size: $--font-size-large;
      margin-top: -2px;
    }

    p {
      color: $--color-text-secondary;
      font-size: $--font-size-small;
    }

    .el-avatar {
      min-width: 45px;
      min-height: 45px;
      margin-left: 10px;
      background: #fff;
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
    }
    .user_icon {
      float: right;
      min-width: 45px;
      min-height: 45px;
      margin-left: 10px;
      border-radius: 10em;
      background: #fff;
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
      display: flex;
      align-items: center;
      justify-content: center;
      .svg-icon {
        width: 20px;
        height: 20px;
        transition: all 0.2s ease;
      }
    }

    &:hover {
      // background-color: #ddd;
      cursor: pointer;
      .svg-icon {
        color: $--color-primary;
      }
    }
  }
}

.mynotice {
  // flex: 1;
  margin-left: 5vw;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.notice {
  position: relative;
  height: 48px;
  // width: 94px;
  // position: relative;
  // text-align: right;
  margin-right: 40px;
  // float: left;
  // display: flex;
  padding-right: 45px;
  h4 {
    width: 40px;
    font-size: $--font-size-large;
  }

  p {
    width: 40px;
    color: $--color-text-secondary;
    font-size: $--font-size-small;
  }

  > div {
    position: absolute;
    right: 0;
    top: 0;
    .notice_icon {
      min-width: 45px;
      min-height: 45px;
      margin-left: 10px;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
      img {
        margin-top: 10px;
      }
      .svg-icon {
        width: 20px;
        height: 20px;
      }
    }

    /deep/ .el-badge__content.is-fixed {
      top: 2px;
      right: 14px;
    }

    /deep/ .el-badge__content {
      border: none;
    }
  }

  &:hover {
    // background-color: #ddd;
    color: $--color-primary;
    cursor: pointer;
  }
}

.pageheader__avatar {
  padding-bottom: 48px;

  h4 {
    max-width: 120px;
    overflow: hidden;
  }

  p {
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
  }

  .expireDate {
    position: absolute;
    right: 12px;
    max-width: 164px;
    color: green;
  }
}

.logout__popover {
  position: relative;
  text-align: center;
  line-height: 32px;
  font-size: 15px;

  .el-avatar {
    width: 80px;
    height: 80px;
    background: none;
    border: 2px solid $--border-color-base;
  }
  h4 {
    font-size: $--font-size-large;
    color: $--color-text-primary;
  }

  p a {
    text-decoration: none;
    color: $--color-primary;
  }
  .btnbar {
    margin-top: 14px;
  }

  .modifyPhone {
    color: $--color-primary;
    cursor: pointer;
  }
}

.selarea {
  position: absolute;
  padding: 4px 10px;
  left: 180px;
  top: 45px;
  border-radius: 10em;
  color: $--color-text-regular;

  svg {
    color: $--color-text-secondary;
    margin-right: 0.2em;
    position: relative;
    top: -2px;
  }

  i {
    margin-left: 0.5em;
    font-size: 0.8em;
  }

  &:after {
    content: "";
  }

  &:hover {
    cursor: pointer;
    background: darken($--background-color-base, 6%);
  }

  &-popper {
    margin: -12px;
    border: 0;
  }
}

.dataSum {
  // position: relative;
  // left: -24px;
  // margin-top: 12px;
  // width: 35%;
  // flex: 1;
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 480px;
  height: 76px;
  display: flex;
  align-items: center;
  // background: #ffffff;
  // background-size: auto 100%;
  background-image: linear-gradient(
    90deg,
    rgba(79, 0, 10, 0.05) 0%,
    rgba(0, 19, 58, 0.05) 100%
  );
  box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.5),
    inset 0 1px 2px 0 rgba(0, 0, 0, 0.03);
  border-radius: 10em;
  display: flex;
  align-items: center;
  &-icon {
    width: 52px;
    height: 52px;
    margin-left: 14px;
    background: #eef2f9;
    border-radius: 10em;
    display: flex;
    align-items: center;
    justify-content: center;
    .svg-icon {
      width: 22px;
      height: 22px;
      color: $--color-primary;
    }
  }
  .el-progress {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 90px;
    right: 48px;
    ::v-deep .el-progress-bar__outer {
      background: #c0c5cd;
    }
    ::v-deep .el-progress-bar__inner:after {
      content: "";
      position: absolute;
      top: 0;
      right: -2px;
      width: 6px;
      height: 100%;
      transform: skew(-45deg);
      background: #fff;
    }
  }

  ul {
    display: flex;
    font-size: $--font-size-small;
    margin: 0 auto;
    width: 70%;
    padding-right: 24px;
    justify-content: space-between;
    li {
      position: relative;
      // text-align: center;
      // padding: 0 20px;
      // width: 15em;
      line-height: 1.5;

      // &:not(:last-child):after {
      //   content: "";
      //   position: absolute;
      //   top: 5%;
      //   right: 0;
      //   transform: rotate(15deg);
      //   width: 1px;
      //   height: 90%;
      //   background: $--border-color-light;
      // }
    }
    .dataSum-num {
      display: flex;
      align-items: center;
    }
    h4 {
      color: $--color-black;
      margin-bottom: 16px;
      margin-top: 4px;
    }

    p {
      font-size: 18px;
      color: $--color-primary;
      display: flex;
      align-items: center;
      justify-content: center;
      small {
        font-size: $--font-size-small;
      }
    }

    .number {
      font-size: 12px;
      margin: 0 16px;
      opacity: 0.6;
    }

    li:nth-child(1) p {
      color: $--color-primary;
    }

    li:nth-child(2) {
      p {
        color: $--color-info;
      }
      h4 {
        text-align: right;
      }
      .dataSum-num {
        flex-direction: row-reverse;
      }
    }
  }

  h6 {
    position: absolute;
    right: 30px;
    top: 82px;
    font-size: 11px;
    color: #b0b0b0;
  }

  .trapTips {
    position: absolute;
    right: 10px;
    top: 2px;
    cursor: pointer;
  }
}

.tipsContent {
  font-size: 13px;
}

.noticeDialog {
  z-index: 2001;

  ul {
    min-height: 300px;

    li {
      height: 30px;
      line-height: 30px;
      margin-bottom: 16px;

      span {
        border-radius: 50%;
        margin-right: 4px;
        margin-bottom: 1px;
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: gray;
      }

      span.unread {
        background-color: red;
      }

      p {
        float: right;
      }
    }

    li:hover {
      background-color: #fcecec;
      color: red;
      cursor: pointer;
    }
  }
}

.noticeDetailDialog {
  z-index: 2002;
  color: #000000;

  h3 {
    text-align: center;
  }

  p {
    text-indent: 2em;
    margin: 40px 0px 50px 0px;
    font-size: 16px;
  }

  div span {
    display: block;
    text-align: right;
    margin-top: 10px;
    font-size: 14px;
  }
}

.smsCodeInput {
  width: 120px;
}

.smsCodeBtn {
  position: absolute;
  right: 0px;
  width: 86px !important;
  padding: 9px 5px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /deep/ .el-loading-spinner {
    margin-top: 0px !important;
    top: 10px !important;
  }
}

.subtitle {
  color: #9e9e9e;
  font-size: 20px;
}
.el-dropdown {
  top: 0;
  left: 0;
  position: absolute;
}
.lang_switch {
  width: 55px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $--color-black;
  .svg-icon {
    width: 20px;
    height: 20px;
  }
}
/deep/ .el-button {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.logo-img {
  height: 90px;
  width: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  img {
    object-fit: contain;
    width: 100%;
  }
}
</style>
